import type { CatalogProps } from '../index';
import { BuyLink, Quote, TplFooter, TplHeader, TplRoot, splitProducts } from '../shared';
import { Countdown } from '../Countdown';

/** Clean Direct Offer — cronômetro no topo, checklist de benefícios, CTA de 1 clique. Lead magnet. */
export default function Catalog({ data, apiBase }: CatalogProps) {
  const { store, products } = data;
  const { feature, grid } = splitProducts(store, products);
  const offer = feature ?? grid[0] ?? null;
  const benefits = grid.filter((p) => p !== offer).slice(0, 5);

  return (
    <TplRoot>
      <div className="bg-white/[0.06] border-b border-white/10 text-center py-2 text-sm text-white/70">
        <span className="text-[var(--sf-accent,#4edea3)] font-semibold">Condição especial</span> — expira em <Countdown />
      </div>

      <TplHeader store={store} apiBase={apiBase} links={['A oferta', 'Depoimentos', 'Garantia']} />

      <main className="max-w-3xl mx-auto px-4 py-10 flex flex-col gap-6 text-center">
        <h1 className="text-3xl md:text-5xl font-black leading-[1.1] tracking-tight">
          {store.tagline ?? `Tudo o que ${store.name} tem de melhor, num pacote só.`}
        </h1>

        {offer ? (
          <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 md:p-8 text-left flex flex-col gap-4">
            <h2 className="text-2xl font-black">{offer.name}</h2>
            {offer.description ? <p className="text-white/60">{offer.description}</p> : null}
            <ul className="flex flex-col gap-2">
              {(benefits.length ? benefits.map((b) => b.name) : ['Acesso imediato', 'Entrega automática']).map((b) => (
                <li key={b} className="flex items-center gap-2 text-sm">
                  <span className="material-symbols-outlined text-[var(--sf-accent,#4edea3)] text-lg">check_circle</span>
                  {b}
                </li>
              ))}
            </ul>
            <BuyLink href={`/p/${offer.slug}`} block className="text-base">
              Liberar meu acesso agora
            </BuyLink>
            <p className="text-xs text-white/50 text-center">PIX instantâneo · acesso enviado no e-mail</p>
          </div>
        ) : null}

        <Quote store={store} />
      </main>

      <TplFooter store={store} />
    </TplRoot>
  );
}
